import { HorizontalDivider, Modal } from '@smartgift/frontend-toolkit';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalValidationErrors } from '@hero/components/molecules';

import { UploadEmailReviewImport, UploadEmailSpreadSheet } from '../NewContactModal/SpreadSheet';

import { UPLOAD_EMAIL_STEPS } from './constant';
import * as S from './style';

function UploadEmailSpreadSheetModal({
  emails = [],
  openModal,
  onRequestClose,
  onEmailUpdateDone,
  isPrimaryButtonDisabled
}) {
  const { t } = useTranslation();
  const emailUploadSteps = {
    [UPLOAD_EMAIL_STEPS.UPLOAD_SPREADSHEET]: UploadEmailSpreadSheet,
    [UPLOAD_EMAIL_STEPS.REVIEW_IMPORT]: UploadEmailReviewImport
  };

  const [uploadedEmails, setUploadedEmails] = useState(emails);
  const [step, setStep] = useState(UPLOAD_EMAIL_STEPS.UPLOAD_SPREADSHEET);
  const [footerProps, setFooterProps] = useState({});
  const [modalHeader, setModalHeader] = useState({
    title: t('uploadEmailList'),
    icon: ''
  });

  const Component = emailUploadSteps[step];

  useEffect(() => {
    if (emails.length) {
      setUploadedEmails(emails);
    }
  }, [emails]);

  return (
    <Modal
      isOpen={openModal}
      onRequestClose={onRequestClose}
      title={modalHeader.title}
      primaryButtonProps={{
        onClick: footerProps?.rightButtonOnClick,
        children: footerProps?.rightButtonText,
        disabled: !footerProps?.isRightButtonActive,
        loading: footerProps?.isRightButtonLoading
      }}
      secondaryButtonProps={{
        onClick: footerProps?.leftButtonOnClick,
        children: footerProps?.leftButtonText,
        disabled: !footerProps?.isLeftButtonActive
      }}
    >
      <ModalValidationErrors style={{ marginBottom: 16 }} />
      <S.ContentWrapper>
        <HorizontalDivider $margin="16px 0" />
        <Component
          setStep={setStep}
          setModalHeader={setModalHeader}
          setFooterProps={setFooterProps}
          onRequestClose={onRequestClose}
          setUploadedEmails={setUploadedEmails}
          uploadedEmails={uploadedEmails}
          onEmailUpdateDone={onEmailUpdateDone}
          isPrimaryButtonDisabled={isPrimaryButtonDisabled}
        />
      </S.ContentWrapper>
    </Modal>
  );
}

export { UploadEmailSpreadSheetModal };
